import { useParams } from "react-router"

import { useActiveOrganizationId } from "@/contexts"
import { isAdminEntityUnavailable } from "@/modules/admin/utils/is-admin-entity-unavailable"
import { useCredential } from "@/services/credential"

export const useAdminCredentialPageState = () => {
  const { activeOrganizationId } = useActiveOrganizationId()
  const { credentialId: credentialIdParam } = useParams()

  const organizationId = activeOrganizationId ?? ""
  const credentialId =
    credentialIdParam == null || credentialIdParam === ""
      ? undefined
      : credentialIdParam

  const {
    credentialData,
    credentialError,
    credentialIsFetched,
    credentialIsLoading,
    credentialIsPlaceholderData,
    ...credentialQueryResult
  } = useCredential({
    credentialId,
    organizationId,
  })

  // Credentials resolve from the org list (`placeholderData: []`). Fold
  // placeholder / list-level errors into isFetched so missing ids still 404
  // immediately via isAdminEntityUnavailable, while empty placeholder does
  // not false-404 and routes can throw list errors instead.
  const credentialIsUnavailable = isAdminEntityUnavailable({
    data: credentialData,
    error: credentialError,
    id: credentialId,
    isFetched:
      credentialIsFetched &&
      !credentialIsPlaceholderData &&
      credentialError == null,
    isUnavailableError: () => false,
  })

  return {
    ...credentialQueryResult,
    credentialData,
    credentialError,
    credentialId,
    credentialIsFetched,
    credentialIsLoading: credentialIsLoading || credentialIsPlaceholderData,
    credentialIsUnavailable,
  }
}
